(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["events-list"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.js-event-list__item-button--presale').forEach(el => {
    const target = el.getAttribute('data-target'),
          details = document.querySelector(`#${target}`),
          content = details.querySelector('.js-event-list__item-details-content')
    el.addEventListener('click', ()=> {
      if (!details.open) {
        details.open = true
        const startHeight = 0,
              endHeight = content.scrollHeight + "px"
        content.animate([{ height: startHeight }, { height: endHeight }], {
            duration: 300,
            easing: "ease-out",
        })
      } else {
        const startHeight = content.scrollHeight + "px",
              endHeight = 0,
              animation = content.animate([{ height: startHeight }, { height: endHeight }], {
                  duration: 300,
                  easing: "ease-in-out",
              })
        animation.onfinish = () => details.open = false
      }
    })
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nav-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nav-menu__list-item').forEach(item => {
  const link = item.querySelector('.nav-menu__list-link[aria-haspopup="true"]');
  if (!link) return;
  let touchedOnce = false;
  const openMenu = () => link.setAttribute('aria-expanded', 'true');
  const closeMenu = () => {
    link.setAttribute('aria-expanded', 'false');
    touchedOnce = false;
  };
  link.addEventListener('touchstart', e => {
    if (!touchedOnce) {
      e.preventDefault();
      link.focus();
      touchedOnce = true;
      openMenu();
    } else {
      window.location.href = link.getAttribute('href');
    }
  });
  item.addEventListener('mouseenter', openMenu);
  item.addEventListener('touchstart', openMenu);
  item.addEventListener('mouseleave', closeMenu);
  document.addEventListener('touchstart', e => {
    if (!item.contains(e.target)) closeMenu();
  });
});
  } catch(e) { console.error(e); }
})();

})();
